import { Link } from "react-router-dom";
import { useProduct } from "@/lib/product";
import { openCookiePanel } from "@/lib/consent";

export const Footer = () => {
  const { product } = useProduct();
  const email = product?.contact_email;
  return (
    <footer data-testid="footer-container" className="bg-slate-950 text-slate-400 pb-28 sm:pb-0">
      <div className="container-x py-14 grid md:grid-cols-[1.2fr_1fr_1fr] gap-10">
        <div className="flex flex-col gap-3">
          <span className="font-display text-2xl font-extrabold text-white tracking-tight">Clim<span className="text-sky-400">Nova</span></span>
          <p className="text-sm leading-relaxed max-w-xs">Vente en ligne du climatiseur split mobile réversible Midea PortaSplit 12 000 BTU.</p>
        </div>
        <address data-testid="footer-company-info" className="not-italic text-sm leading-relaxed flex flex-col gap-1">
          <span className="text-white font-semibold mb-1">Éditeur</span>
          <span>ClimNova est une marque exploitée par Robert CLERC EI (EAUVÈO) – 47 rue Vivienne 75002 Paris – RCS Paris 378 932 396 – TVA FR74 378 932 396</span>
          {email && <a href={`mailto:${email}`} data-testid="footer-email" className="hover:text-white transition-colors">{email}</a>}
        </address>
        <nav className="flex flex-col gap-2 text-sm">
          <span className="text-white font-semibold mb-1">Informations légales</span>
          <Link to="/mentions-legales" data-testid="footer-link-legal" className="hover:text-white transition-colors">Mentions légales</Link>
          <Link to="/cgv" data-testid="footer-link-cgv" className="hover:text-white transition-colors">Conditions générales de vente</Link>
          <Link to="/politique-confidentialite" data-testid="footer-link-privacy" className="hover:text-white transition-colors">Politique de confidentialité</Link>
          <Link to="/charte-des-avis" data-testid="footer-link-reviews-charter" className="hover:text-white transition-colors">Charte des avis</Link>
          <button type="button" onClick={openCookiePanel} data-testid="footer-manage-cookies" className="text-left hover:text-white transition-colors">Gérer les cookies</button>
        </nav>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-5 text-xs flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} ClimNova — EAUVÈO. Tous droits réservés.</span>
          <span>Midea et PortaSplit sont des marques de leurs propriétaires respectifs. Visuels non contractuels.</span>
        </div>
      </div>
    </footer>
  );
};
